'use strict';

// @flow

var FirebaseClockOffset = function FirebaseClockOffset() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { loading: true };
  var action = arguments[1];

  switch (action.type) {
    case 'FIREBASE_CLOCK_OFFSET':
      // Ignore the action if the new value is coming from AsyncStorage
      // but we already have a value from Firebase
      if (state.source === 'Firebase' && action.source === 'AsyncStorage') {
        return state;
      }

      return Object.assign({}, state, {
        loading: false,
        value: action.value,
        source: action.source
      });

    default:
      return state;
  }
};

module.exports = FirebaseClockOffset;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fibo-app/fibo-collab-shared/build/clients/reducers/FirebaseClockOffset.js
// module id = 1021
// module chunks = 0